import invariant from 'invariant';
import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import queryString from 'query-string';

export default function getPromoCode(params) {
    let { baseUrl, brandId, country, language, options, clientId, uberToken, clientSecret } = params;

    invariant(baseUrl, 'baseUrl is a required param of getPromoCode()');
    invariant(brandId, 'brandId is a required param of getPromoCode()');
    invariant(country, 'country is a required param of getPromoCode()');
    invariant(language, 'language is a required param of getPromoCode()');
    invariant(options?.partnumber, 'options.partnumber is a required param of getPromoCode()');
    invariant(clientId, 'clientId is a required param of getPromoCode()');

    const localisedBrand = `${brandId}_${country.toLowerCase()}`;

    const queryParams = {
        ...options,
        DM_ReqCmd: 'ProductDisplay',
    };

    const queries = queryParams ? `?${queryString.stringify(queryParams)}` : '';

    const concatUrl = `${baseUrl}wcs/resources/store/${localisedBrand}/espot/PromotionPDPPrice${queries}`;
    return labelRequest(authenticatedRequest(new Request(concatUrl), uberToken, clientId, clientSecret), 'getPromoCode');
}
